import { Controller } from '@hotwired/stimulus';
import { stripeGatewayLoadForm, rebuildPaymentElement } from '../../modules/checkout/stripe';
import { stripePaymentIntentCheckoutEnabled } from '../../modules/checkout/checkoutHelpers';
import {
  stripeCheckoutSessionLoadForm,
  rebuildCheckoutSessionElement,
} from '../../modules/checkout/stripe_checkout_session';

const checkoutFormEl = () => document.getElementById('payment-form');

const payNowButtonEl = () => document.querySelector(
  '[data-enrollment-engine--checkout-target="payNowButton"]',
);

export default class extends Controller {
  static targets = ['paymentIntentForm', 'checkoutSessionForm']

  connect () {
    this.loadForm();
  }

  loadForm () {
    if (!stripePaymentIntentCheckoutEnabled()) {
      return;
    }

    this.disableCheckoutForm();
    this.listenToPaymentFormChange();

    this.mountElement()
      .then(() => this.enableCheckoutFormUnlessError())
      .catch(() => {
        // TODO: SELL-1044
        // This logic is only for subsequent payments
        this.enableCheckoutForm();
        this.disablePayNowButton();
      });
  }

  async mountElement () {
    if (this.hasCheckoutSessionFormTarget) {
      return this.remountRequired()
        ? rebuildCheckoutSessionElement()
        : stripeCheckoutSessionLoadForm();
    }

    return this.remountRequired() ? rebuildPaymentElement() : stripeGatewayLoadForm();
  }

  remountRequired () {
    return this.stripeFormTarget()?.dataset?.remountRequired === 'true';
  }

  stripeFormTarget () {
    return this.hasCheckoutSessionFormTarget
      ? this.checkoutSessionFormTarget
      : this.paymentIntentFormTarget;
  }

  // eslint-disable-next-line class-methods-use-this
  listenToPaymentFormChange () {
    const checkoutForm = checkoutFormEl();

    if (!checkoutForm) {
      return;
    }

    checkoutForm.addEventListener('payment_form_change', (event) => {
      const payNowButton = payNowButtonEl();

      if (payNowButton) {
        payNowButton.disabled = event.detail.disable_payment;
      }
    });
  }

  enableCheckoutFormUnlessError () {
    const alertLabel = document.querySelector('.alert-danger');

    if (!alertLabel || alertLabel.classList.contains('d-none')) {
      this.enableCheckoutForm();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  disableCheckoutForm () {
    const checkoutForm = checkoutFormEl();

    if (checkoutForm) {
      checkoutForm.classList.add('disabled');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  enableCheckoutForm () {
    const checkoutForm = checkoutFormEl();

    if (checkoutForm) {
      checkoutForm.classList.remove('disabled');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  disablePayNowButton () {
    const payNowButton = payNowButtonEl();

    if (payNowButton) {
      payNowButton.disabled = true;
    }
  }
}
